import { useEffect, useState } from "react"; 

import NavBar from '../components/NavBar/NavBar'
import Banner from '../Componentes/Banners/Banner';
import UsoDelEquipo from '../Componentes/UsoDelEquipo/UsoDelEquipo';
import SolucionDeProblemas from '../Componentes/SolucionDeProblemas/SolucionDeProblemas';
import Video from "../Componentes/Video/video";
import ManualesYDocumentos from '../Componentes/ManualesYDocumentos/ManualesYDocumentos2item.';
import RedesSociales from '../Componentes/RedesSociales/RedesSociales';
import Footer from '../Componentes/Footer/Footer'
import InfoPrincipal from '../Componentes/InfoPrincipal/InfoPrincipal';

import { obtenerDataBanner } from '../Componentes/infoJsons/infoBanner.js'
import { obtenerInfoPrin_BR855 } from '../Componentes/infoJsons/infoPrincipal.js'
import { obtenerUSO_BR855 } from '../Componentes/infoJsons/infoUsoDelEquipo.js'
import { obtenerSDP_BR855 } from '../Componentes/infoJsons/infoSoluDeProble.js';

const BR855B = () => {

      //Banner
      const [data, setData] = useState([]);
      //
    
      //inFo Principal
        const [infoPrinc, setInfoPrinc] = useState([]);
      //
    
      //UsoDelEquipo
        const [USO_SC250, setUSO_SC250] = useState([]);
      //

      //Solucion de Problemas
        const [SDP_SC250, setSDP_SC250] = useState([]);
      //
    
        useEffect(() => {
    
            //Banner
            obtenerDataBanner().then(myJson => {setData(myJson);});
    
            //INFOPRINCIPAL
            obtenerInfoPrin_BR855().then(infoPrincipal => {setInfoPrinc(infoPrincipal);});
    
            //USODELEQUIPO
            obtenerUSO_BR855().then(uso => {setUSO_SC250(uso);});
            //

            //SOLUCION DE PROBLEMA
            obtenerSDP_BR855().then(SDP => {setSDP_SC250(SDP)});
            //
        }, []);

        const listas = []
        
        const listasDesc2 = []

        const listasDesc3 = []



        const videos = [
            "https://nilfiskchile.cl/assets/videos/BR855/BR855_Viper_video Uso y cuidado_esp.mp4"
          ];
          
          const posters = [
            "https://nilfiskchile.cl/assets/videos/BR855/BR855_video.jpg"
          ];
          
          const thumbnails = [
            "https://nilfiskchile.cl/assets/videos/BR855/BR855_video.jpg"
          ];

          const elementosCarrusel = [
            {
              imgSrc: "https://nilfiskchile.cl/assets/img/BR855/Manuales/uso-y-mantencion.jpg",
              pdf: "https://nilfiskchile.cl/assets/img/BR855/Manuales/BR855_ Uso_mantencion_espannol_Chile.pdf",
              label: 'Uso Y Mantenimiento',
            },
            {
              imgSrc: "https://nilfiskchile.cl/assets/img/BR855/Manuales/catalogo.jpg",
              pdf: "https://nilfiskchile.cl/assets/img/BR855/Manuales/BR855_Catalogo_espannol_Chile.pdf",
              label: 'Catálogo',
            }
          ];

    return (

        <div>
            <NavBar/>
            <Banner imageClass="BannerFregadora" titulo={data.length > 0 ? data[0].tituloBarredora : ""} />
            <InfoPrincipal data={infoPrinc} listas={listas} listasDesc2={listasDesc2} listasDesc3={listasDesc3}/>
            <UsoDelEquipo data={USO_SC250}/>
            <SolucionDeProblemas problemas={SDP_SC250}/>
            <Video videos={videos} posters={posters} thumbnails={thumbnails}  />
            <ManualesYDocumentos elementosCarrusel={elementosCarrusel} />
            <RedesSociales />
            <Footer />
        </div>

    );
};

export default BR855B;